// extracted by mini-css-extract-plugin
export default {"element":"NavElement_element__cylPw","link":"NavElement_link__0B2tz","move":"NavElement_move__hSDyJ","black":"NavElement_black__OXf27","white":"NavElement_white__m0iIT"};